<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-comment-alert
      </v-icon>
        <span class="px-2">{{$t('complaints')}}</span>
      </v-card-title>
      <v-tabs v-model="active_tab" show-arrows class="my-2">
        <v-tab v-for="tab in translatedTabs" :key="tab.idx">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
    <v-tabs-items v-model="active_tab">
      <!-- active -->
      <v-tab-item>
        <complaints-table :complaints="activeComplaints" :is-loading="isLoading" :is-active="true"
        @view-complaint="viewComplaint"
        @refund-complaint="refundComplaint"
        @cancel-complaint="cancelComplaint"
        ></complaints-table>
      </v-tab-item>

      <!-- completed -->
      <v-tab-item>
        <complaints-table :complaints="completedComplaints" :is-loading="isLoading" :is-active="false"
        @view-complaint="viewComplaint"
        @refund-complaint="refundComplaint"
        @cancel-complaint="cancelComplaint"
        @view-response="viewResponse"
        ></complaints-table>
      </v-tab-item>

      <!-- driver complaints -->
      <v-tab-item>
        <driver-complaints-tab></driver-complaints-tab>
      </v-tab-item>

      <!-- driver reports -->
      <v-tab-item>
        <driver-reports-tab></driver-reports-tab>
      </v-tab-item>

      <!-- complaint suggestions -->
      <v-tab-item>
        <complaint-suggestions-tab></complaint-suggestions-tab>
      </v-tab-item>

    </v-tabs-items>
    </v-card>
  </div>
</template>

<script>

import {
  mdiAccountCheck,
  mdiPlayCircleOutline,
  mdiCommentAlert,
  mdiAlertBox,
  mdiLightbulbOn,
} from "@mdi/js";

import complaintsTable from "./complaints-table.vue";
import DriverComplaintsTab from "./driver-complaints-tab.vue";
import DriverReportsTab from "./driver-reports-tab.vue";
import ComplaintSuggestionsTab from "./complaint-suggestions-tab.vue";
import auth from '@/services/AuthService';

export default {
  components: {
    complaintsTable,
    DriverComplaintsTab,
    DriverReportsTab,
    ComplaintSuggestionsTab,
  },
  data() {
    return {
      isLoading: false,
      activeComplaints: [],
      completedComplaints: [],
      tabs: [
        { idx: 0, title: "active", icon: mdiPlayCircleOutline },
        { idx: 1, title: "completed", icon: mdiAccountCheck },
        { idx: 2, title: "driver_complaints", icon: mdiCommentAlert },
        { idx: 3, title: "driver_reports", icon: mdiAlertBox },
        { idx: 4, title: "complaint_suggestions", icon: mdiLightbulbOn },
      ],
      active_tab: null,
      icons: {
        mdiAccountCheck,
        mdiPlayCircleOutline,
        mdiCommentAlert,
        mdiAlertBox,
        mdiLightbulbOn,
      },
    };
  },
  watch: {
    active_tab: function (newVal, oldVal) {
      localStorage.tabIdxComplaints = newVal;
    },
  },
  computed: {
    translatedTabs() {
      return this.tabs.map(tab => ({
        ...tab,
        title: this.$t(tab.title)
      }));
    },
  },
  mounted() {
    this.active_tab = parseInt(localStorage.tabIdxComplaints) || 0;
    this.loadComplaints();
  },
  methods: {
    loadComplaints() {
      this.isLoading = true;
      this.activeComplaints = [];
      this.completedComplaints = [];
      axios
        .get(`/complaints/all`)
        .then((response) => {
          this.activeComplaints = response.data.active;
          this.completedComplaints = response.data.completed;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: this.$t("error_retrieving_complaints"),
            type: "error",
          });
          console.log(error);
          auth.checkError(error.response.data.message, this.$router, this.$swal);
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    viewComplaint(complaint) {
      //swal with the complaint message
      this.$swal({
        title: this.$t("complaint"),
        html: complaint.complaint,
        icon: "info",
        showCancelButton: false,
        confirmButtonText: this.$t("ok"),
      });
    },
    viewResponse(complaint) {
      //swal with the complaint message
      this.$swal({
        title: this.$t("response"),
        html: complaint.response,
        icon: "info",
        showCancelButton: false,
        confirmButtonText: this.$t("ok"),
      });
    },

    cancelComplaint(complaint, index) {
      this.$swal({
        input: 'textarea',
        inputPlaceholder: this.$t('cancel_complaint_reason'),
        inputAttributes: {
          'aria-label': this.$t('cancel_complaint_reason')
        },
        title: this.$t("cancel_complaint"),
        html: this.$t("confirm_cancel_complaint"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yes_cancel_complaint"),
        cancelButtonText: this.$t("cancel"),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          this.takeActionOnComplaintServer(complaint.id, result.value, index, "cancel");
        }
      });
    },

    refundComplaint(complaint, index) {
      this.$swal({
        input: 'textarea',
        inputPlaceholder: this.$t('refund_complaint_reason'),
        inputAttributes: {
          'aria-label': this.$t('refund_complaint_reason')
        },
        title: this.$t("refund_complaint"),
        html: this.$t("confirm_refund_complaint"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yes_refund_complaint"),
        cancelButtonText: this.$t("cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.takeActionOnComplaintServer(complaint.id, result.value, index, "refund");
        }
      });
    },

    takeActionOnComplaintServer(complaint_id, responseText, index, action) {
      this.isLoading = true;
      axios
        .post(`/complaints/take-action`, {
          complaint_id: complaint_id,
          response: responseText,
          action: action,
        })
        .then((response) => {
          this.$notify({
            title: this.$t("Success"),
            text: action === "cancel" ? this.$t("complaint_cancelled") : this.$t("complaint_refunded"),
            type: "success",
          });
          let complaintWithAction = this.activeComplaints[index];
          complaintWithAction.response = responseText;
          complaintWithAction.action = action;

          //add to completed in first position
          this.completedComplaints.unshift(complaintWithAction);
          this.activeComplaints.splice(index, 1);
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: action === "cancel" ? this.$t("error_cancelling_complaint") : this.$t("error_refunding_complaint"),
            type: "error",
          });
          this.$swal("Error", error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
